<script>
  import { cart } from "../../services/cart-service";
  export let cartURL;
</script>

<a href={cartURL} id="cart" role="button" class="btn text-nowrap">
  <i class="bi bi-cart-fill me-1"></i>
  <strong>
    Cart
  </strong>
  {#if $cart && $cart.length > 0}
    <span class="badge rounded-pill bg-danger ms-1">{$cart.length}</span>
  {/if}
</a>

<style>
  #cart {
    --bs-btn-color: white;
    --bs-btn-hover-color: white;
    --bs-btn-active-color: white;
  }
</style>
